import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { LoginService } from 'src/app/services/login.service'
import { WEBSITE_URL } from 'src/app/shared/constants/website-constant'

@Component({
  selector: 'app-multi-factor-authentication',
  templateUrl: './multi-factor-authentication.component.html',
  styleUrls: ['./multi-factor-authentication.component.less'],
})
export class MultiFactorAuthenticationComponent implements OnInit {
  verifyButtonDisabled = true
  MFApin = ''
  @Input() MFAData!: any
  @Output() MFAverified = new EventEmitter()
  @Output() LoginWithRecovery = new EventEmitter()
  constructor(private loginService: LoginService) {}
  codeError = false
  ngOnInit(): void {}
  logoURL = '../assets/images/logo.svg'
  webURL: string = WEBSITE_URL
  onMFAChange(pin: any) {
    this.MFApin = pin
    this.codeError = false
    if (pin.toString().length === 6 && this.verifyButtonDisabled === true) {
      this.verifyMFAPin(pin)
      this.verifyButtonDisabled = false
    } else if (pin.toString().length !== 6) {
      this.verifyButtonDisabled = true
    }
  }

  /**
   * Verifys mfapin
   */
  verifyMFAPin(pin: any) {
    const payload = {
      member_id: this.MFAData?.member_id,
      secretCodeMFA: this.MFAData?.secretCodeMFA ?? '',
      token: pin ?? '',
      member_email: this.MFAData?.member_email ?? '',
      member_password: this.MFAData?.member_password ?? '',
    }

    this.loginService.verifyMFA(payload).subscribe({
      next: (res: any) => {
        this.MFAverified.emit(res)
      },
      error: (res: any) => {
        this.codeError = true
      },
    })
  }
}
